import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=2597ac0e&scoped=true"
import script from "./TemplateItem.vue?vue&type=script&lang=js"
export * from "./TemplateItem.vue?vue&type=script&lang=js"
import style0 from "./TemplateItem.vue?vue&type=style&index=0&id=2597ac0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2597ac0e",
  null
  
)

export default component.exports